<template>
  <ResearchGalleryPage
    page-title="职工集体活动"
    section-label="科研保障"
    :section-route="sectionRoute"
    :top-strip-image="topStripImage"
    :hero-background-image="heroBackgroundImage"
    :groups="groups"
  />
</template>

<script>
import ResearchGalleryPage from '@/components/ResearchGalleryPage.vue';

export default {
  name: 'LanhuZhigongjitihuodong',
  components: {
    ResearchGalleryPage
  },
  data() {
    return {
      sectionRoute: '/lanhu_keyanbaozhang',
      topStripImage: require('@/views/lanhu_jigouyulishi/assets/img/SketchPnge6526ecb2fcab0802b546f04824fe8f83db80e06fef6b8cf3b08d187c494f182.png'),
      heroBackgroundImage: require('@/views/lanhu_zhengwenyexueshuchengguo/assets/img/173301bb9c6d42d7ae3028c182487260_mergeImage.png'),
      groups: [
        {
          title: '早期职工活动与主题参观',
          kicker: '1988-2006',
          items: [
            {
              src: require('./assets/html/staff-1988-heilongtan.jpg'),
              caption: '1988 年 10 月，新闻研究所职工秋游黑龙潭'
            },
            {
              src: require('./assets/html/staff-1991-jinhaihu.jpg'),
              caption: '1991 年 10 月，新闻研究所职工秋游金海湖',
              wide: true
            },
            {
              src: require('./assets/html/staff-1997-group.jpg'),
              caption: '1997 年，新闻与传播研究所组织职工集体活动'
            },
            {
              src: require('./assets/html/staff-2002-jinggangshan.jpg'),
              caption: '2002 年 4 月，新闻与传播研究所党委组织职工赴革命摇篮井冈山参观'
            },
            {
              src: require('./assets/html/staff-2006-jiaozuo.jpg'),
              caption: '2006 年 5 月，新闻与传播研究所党委书记张昌东带领职工在河南省焦作市参观'
            }
          ]
        },
        {
          title: '读书会、妇工委与集体荣誉',
          kicker: '2012-2018',
          items: [
            {
              src: require('./assets/html/staff-2018-women.jpg'),
              caption: '2018 年 3 月，新闻与传播研究所妇工委组织职工参观故宫博物院庆祝“三八”节'
            },
            {
              src: require('./assets/html/staff-2012-donation.jpg'),
              caption: '2012 年 2 月，新闻与传播研究所办公室组织职工参加院义务献血活动'
            },
            {
              src: require('./assets/html/staff-2018-gugong.jpg'),
              caption: '2018 年 4 月，新闻与传播研究所综合办公室荣获“中国社会科学院巾帼建功先进集体荣誉称号”，图为院橱窗照片'
            },
            {
              src: require('./assets/html/staff-2017-reading.jpg'),
              caption: '近年来，新闻与传播研究所坚持开展青年读书会活动。图为 2017 年 6 月，所青年学者交流《人类简史》读后感',
              wide: true
            },
            {
              src: require('./assets/html/staff-honor-certificate.jpg'),
              caption: '荣誉证书',
              tall: true
            }
          ]
        },
        {
          title: '工会组织文体活动',
          kicker: '2013-2018',
          items: [
            {
              src: require('./assets/html/staff-2013-bowling.jpg'),
              caption: '2013 年 10 月，新闻与传播研究所工会组织职工参加院保龄球比赛'
            },
            {
              src: require('./assets/html/staff-2014-rope.jpg'),
              caption: '2014 年 4 月，新闻与传播研究所工会组织职工参加院跳绳比赛'
            },
            {
              src: require('./assets/html/staff-2015-broadcast.jpg'),
              caption: '2015 年 4 月，新闻与传播研究所工会组织职工参加院广播操比赛'
            },
            {
              src: require('./assets/html/staff-2015-sports.jpg'),
              caption: '2015 年 9 月，新闻与传播研究所工会组织职工参加院运动会',
              wide: true
            },
            {
              src: require('./assets/html/staff-2018-badminton.jpg'),
              caption: '2018 年 5 月，新闻与传播研究所工会组织职工参加院羽毛球比赛'
            }
          ]
        }
      ]
    };
  }
};
</script>
